import React from 'react'
import { encodeForURL } from '../../../../global/formatters/string-formatter'
import { isLocal } from '../../../utility'

export function BlogSharing({ title }) {
  const _href = encodeURIComponent(window.location.href)

  const _pageTitleEncoded = encodeURIComponent(title)

  const _hrefLinkedIn = `https://www.linkedin.com/sharing/share-offsite/?url=${_href}`
  const _hrefTwitter = `https://twitter.com/intent/tweet?url=${_href}&text=${_pageTitleEncoded}`
  const emailLink = `mailto:?subject=${title}&body=${title}`
  const encodeEmailLink = `${encodeForURL(emailLink)}${encodeURI(
    '\r\n\r\n'
  )}${encodeForURL(window.location.href)}`

  return (
    <div className="BlogSocial">
      <div className="u-flex u-flexAlignItemsCenter u-flexJustifyEnd">
        <div className="u-textSecondary u-textBold">Share:</div>
        <div
          className="u-flex u-flexAlignItemsCenter u-marginLeft3gu"
          data-analytics="social-media-links-btn"
        >
          <div className="u-flex u-flexAlignItemsCenter">
            <div>
              <img
                src={`${
                  isLocal() ? '/cti-site' : ''
                }/webfiles/latest/assets/cti/images/icon_linkedin.svg`}
                alt="LinkedIn"
              />
            </div>
            <div className="u-marginLeft1gu">
              <a
                className="Link"
                href={_hrefLinkedIn}
                target="_blank"
                rel="noreferrer"
                data-analytics="linkedin-btn"
              >
                LinkedIn
              </a>
            </div>
          </div>
          <div className="u-flexAlignItemsCenter u-marginLeft5gu u-hidden">
            <div>
              <img
                src={`${
                  isLocal() ? '/cti-site' : ''
                }/webfiles/latest/assets/cti/images/icon_twitter.svg`}
                alt="Twitter"
              />
            </div>
            <div className="u-marginLeft1gu">
              <a
                className="Link"
                href={_hrefTwitter}
                target="_blank"
                rel="noreferrer"
                data-analytics="twitter-btn"
              >
                Twitter
              </a>
            </div>
          </div>
          <div className="u-flex u-flexAlignItemsCenter u-marginLeft5gu">
            <div>
              <img
                src={`${
                  isLocal() ? '/cti-site' : ''
                }/webfiles/latest/assets/cti/images/icon_email.svg`}
                alt="Email"
              />
            </div>
            <div className="u-marginLeft1gu">
              <a
                className="Link"
                href={encodeEmailLink}
                target="_blank"
                rel="noreferrer"
                data-analytics="email-btn"
              >
                Email
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
